import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {getCookie, home} from './common/js/cookie'

/* stylus */
import './common/stylus/index.styl'

/* element-ui */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let isLogin = getCookie('abc')
  console.log('to.path', to.path)
  if (!isLogin) { // 没有登录
    window.location.href = home
  } else { // 已经登录
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js